import React from 'react'
import Lottie from "lottie-react"
import propTypes from "prop-types"
export const LottieImage = ({ src = "", height = 125, ...rest}) => {
    return (
        <Lottie   style={{ height:height }}
            animationData={src} {...rest}
        />
    )
}

LottieImage.propTypes = {
    src: propTypes.any,
    height: propTypes.number,   
}